<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Inventory Tickets Details
        <small>List of Inventory Ticket</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a @click="$router.push({ name: 'dashboard' })">
            <i class="fa fa-dashboard"></i> Dashboard
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'inventory-index' })">
            <i class="fa fa-gift"></i> Inventory
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'inventory-view' })">
            <i class="fa"></i> Details
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <div class="box-title">
            <h3>{{ params.flaging === 'explore' ? 'Explore: '+title : 'Tour: '+title }}</h3>
          </div>
        </div>

        <div class="box-body">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Item ID</th>
                <th>Unique Code</th>
                <th>Validity Date From</th>
                <th>Validity Date To</th>
                <th>Is Booked</th>
                <th>Booked At</th>
                <th>Is Sold</th>
                <th>Sold At</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="inventory in inventorys">
                <td>{{ inventory.id }}</td>
                <td>{{ inventory.unique_code }}</td>
                <td>{{ inventory.validity_date_from }}</td>
                <td>{{ inventory.validity_date_to }}</td>
                <td>{{ inventory.is_booked }}</td>
                <td>{{ inventory.booked_at == "0001-01-01" ? "" : inventory.booked_at }}</td>
                <td>{{ inventory.is_sold }}</td>
                <td>{{ inventory.sold_at == "0001-01-01" ? "" : inventory.sold_at }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="box-footer">
          <Pagination
            :pagination="pagination"
            @goto-page="changePage" />
          <a class="btn btn-default pull-right"
            @click.prevent="back">
            Back to Inventory List
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'InventoryView',

  mixins: [Common],

  components: {
    Pagination,
  },

  data() {
    return {
      title: 'Loading Ticket..',
      params: {
        flaging: null,
      },
      inventorys: [],
      pagination: {},

      inventory: {
        id: null,
        name: null,
        unique_code: null,
        validity_date_from: null,
        validity_date_to: null,
        is_booked: null,
        booked_atTime: null,
        booked_atValid: null,
        is_sold: null,
        sold_atTime: null,
        sold_atValid: null,
      },
    };
  },

  methods: {
    back() {
      this.$router.go(-1);
    },

    fetch(page) {
      const pageQuery = page || this.$route.query.page;

      const params = {
        page: pageQuery,
      };

      this.axios.get(`/ticketItems/${this.$route.params.id}`, { params })
        .then((response) => {
          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            return;
          }

          this.inventorys = data;
          this.pagination = meta.pagination;
        });

      if (pageQuery) {
        window.history.pushState(
          `Inventorys page: ${pageQuery}`, 
          null, 
          `/inventory/${this.$route.params.id}?flaging=${this.params.flaging}?page=${pageQuery}`);
      }
    },

    fetchTicket() {
      this.axios.get(`/tickets/${this.$route.params.id}`)
        .then((response) => {
          const { data } = response.data;
          this.title = data.name;
        });
    },

    changePage(page) {
      this.fetch(page);
    },

    add() {
      this.$router.push({
        name: 'inventory-create',
      });
    },

    view(id) {
      this.$router.push({
        name: 'inventory-view',
        params: { id },
      });
    },
  },

  created() {
    this.params.flaging = this.$route.query.flaging || null;
    this.fetchTicket();
    this.fetch();
  },
};
</script>
<style lang="scss" scoped>
  .content{
    overflow: auto;
  }
  th{
    min-width: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/inventory/View.vue